export default __webpack_public_path__ + "static/media/Group 297.4e6d9936.png";